import { lazy, Suspense } from "react";
import HttpsRedirect from "react-https-redirect";
import "./App.css";
import Headline from "./components/Headline";
import NavBar from "./components/NavBar";
import CoreComp from "./components/CoreComp";
import PreviousExperience from "./components/PreviousExperience";
import AboutMe from "./components/AboutMe";
import Footer from "./components/Footer";

// * Below the fold / behind a button, so load their code (forms, validation, API clients) separately
const LetsTalk = lazy(() => import("./components/LetsTalk"));
const ChatBot = lazy(() => import("./components/Custom/ChatBot"));

const enableChatbot = process.env.REACT_APP_ENABLE_CHATBOT === "true";

function App() {
  return (
    <HttpsRedirect>
      <div className="safe-area">
        <NavBar />
        <Headline />
        <CoreComp />
        <PreviousExperience />
        <AboutMe />
        <Suspense fallback={null}>
          <LetsTalk />
        </Suspense>
        <Footer />
        {enableChatbot && (
          <Suspense fallback={null}>
            <ChatBot />
          </Suspense>
        )}
      </div>
    </HttpsRedirect>
  );
}

// ? Check for memory usage.
// const memoryEntries = performance.memory;
// console.log("Memory Usage:", memoryEntries);
export default App;
